<template>
    <el-dialog title="提现申请" :visible.sync="dialogShow" @close="closeDialog" @open="openDialog">

        <el-alert
                title="请在右上角“个人中心”菜单中，绑定Google验证码。"
                type="info"
                show-icon>
        </el-alert>

        <el-form :model="form" :rules="rules" ref="form" style="margin-top: 20px;">


            <el-form-item label="可用余额" :label-width="formLabelWidth" prop="amount">
                <el-col :span="12">
                    <el-input v-model="balance1" autocomplete="off" placeholder="请输入提现金额" disabled></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="提现金额" :label-width="formLabelWidth" prop="amount">
                <el-col :span="12">
                    <el-input v-model="form.amount" autocomplete="off" placeholder="请输入提现金额"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="手续费" :label-width="formLabelWidth" prop="withdrawFee">
                <el-col :span="12">
                    <el-input v-model="withdrawFee" autocomplete="off" disabled></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="总提现金额" :label-width="formLabelWidth" prop="withdrawFee">
                <el-col :span="12">
                    <el-input v-model="totalAmount" autocomplete="off" disabled></el-input>
                </el-col>
            </el-form-item>

            <!-- <el-form-item label="银行名称" :label-width="formLabelWidth" prop="bankName">
                <el-col :span="12">
                    <el-select v-model="form.bankName" placeholder="--请选择--" @change="bankNameChange">
                        <el-option v-for="bankInfo in bankList" :key="bankInfo.bankCode" :label="bankInfo.bankName"
                                   :value="bankInfo.bankCode"></el-option>
                    </el-select>

                </el-col>
            </el-form-item> -->

            <!-- <el-form-item label="支行名称" :label-width="formLabelWidth" prop="bankName">
                <el-col :span="12">
                    <el-input v-model="form.branchName" autocomplete="off" placeholder="请输入提现提现银行"></el-input>
                </el-col>
            </el-form-item> -->

            <el-form-item label="account" :label-width="formLabelWidth" prop="certName">
                <el-col :span="12">
                    <el-input v-model="form.certName" autocomplete="off" placeholder="请输入 ACCOUNT NUMBER"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="IFSC" :label-width="formLabelWidth" prop="bankCardNo">
                <el-col :span="12">
                    <el-input v-model="form.bankCardNo" autocomplete="off" placeholder="请输入 IFSC CODE"></el-input>
                </el-col>
            </el-form-item>

            <!-- <el-form-item label="支付密码" :label-width="formLabelWidth" prop="payPassword">
                <el-col :span="12">
                    <el-input type="password" v-model="form.payPassword" autocomplete="off"
                              placeholder="请输入支付密码"></el-input>
                </el-col>
            </el-form-item>

            <el-form-item label="Google验证码" :label-width="formLabelWidth" prop="googleAuthCode">
                <el-col :span="12">
                    <el-input v-model.number="form.googleAuthCode" autocomplete="off"
                              placeholder="请输入Google验证码"></el-input>
                </el-col>
            </el-form-item> -->

        </el-form>

        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="saveMerchant">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import md5 from 'js-md5';

    export default {
        name: "SystemEdit",
        props: {
            show: Boolean,
            formData: Object,
            action: String,
            balance: String,
            productId: String
        },
        // created() {
        //     this.$axios.get("/agent/selectListForOption", {params: {}}).then(res => {
        //         this.agentList = res.data;
        //     })
        // },
        data() {
            return {
                dialogShow: this.show,
                form: {
                    certName: "",
                    bankCardNo: "",
                    amount: 0,
                    bankName: "",
                    bankCode: "",
                    payPassword: "",
                    googleAuthCode: ""
                },
                balance1: this.balance,
                productId1: this.productId,
                withdrawFee: "正在获取手续费",
                // agentList: [],
                formLabelWidth: '120px',
                rules: {
                    amount: [
                        {required: true, message: '请输入提现金额', trigger: 'blur'}
                    ],
                    bankCardNo: [
                        {required: true, message: '请输入正确的 IFSC CODE', trigger: 'blur'},
                        {min: 0, max: 20, message: '请输入6到20个数字', trigger: 'blur'},
                    ],
                    bankName: [
                        {required: false, message: '请选择银行卡', trigger: 'blur'}
                    ],
                    certName: [
                        {required: true, message: '请输入 ACCOUNT NUMBER', trigger: 'blur'}
                    ],
                    payPassword: [
                        {required: false, message: '请输入提现密码', trigger: 'blur'},
                        {min: 6, max: 20, message: '请输入6到20位的支付密码', trigger: 'blur'}
                    ],
                    googleAuthCode: [
                        {required: false, message: '请输入Google验证码', trigger: 'blur'},
                        {type: 'number', message: 'Google验证码必须为数字', trigger: 'blur'}
                    ]
                },
                bankList: [
                    {bankName: "中国农业银行", bankCode: "ABC"},
                    {bankName: "北京银行", bankCode: "BOB"},
                    {bankName: "中国银行", bankCode: "BOC"},
                    {bankName: "交通银行", bankCode: "BOCM"},
                    {bankName: "上海银行", bankCode: "BOS"},
                    {bankName: "中国建设银行", bankCode: "CCB"},
                    {bankName: "中国光大银行", bankCode: "CEBB"},
                    {bankName: "兴业银行", bankCode: "CIB"},
                    {bankName: "招商银行", bankCode: "CMB"},
                    {bankName: "中国民生银行", bankCode: "CMBC"},
                    {bankName: "中信银行", bankCode: "CNCB"},
                    {bankName: "浙商银行", bankCode: "CZBANK"},
                    {bankName: "广发银行", bankCode: "GDB"},
                    {bankName: "华夏银行", bankCode: "HXB"},
                    {bankName: "中国工商银行", bankCode: "ICBC"},
                    {bankName: "平安银行", bankCode: "PAB"},
                    {bankName: "中国邮政储蓄银行", bankCode: "PSBC"},
                ]
            }
        },

        methods: {

            bankNameChange(value) {
                let obj = {};
                obj = this.bankList.find((item) => {
                    return item.bankCode === value;
                });
                this.form.bankName = obj.bankName;
                this.form.bankCode = value;
            },

            agentNameChange() {

            },

            openDialog() {
                if (this.formData != null) {

                } else {
                    this.$refs.form.resetFields(); //关闭的时候重置表单
                }




            },
            closeDialog() {
                this.dialogShow = false;
                this.$refs.form.resetFields(); //关闭的时候重置表单
                this.$emit('update:show', false);
            },

            saveMerchant() {

                if (this.action === "addWithdraw") {
                    this.$refs['form'].validate((valid) => {
                        if (valid) {

                            let obj = Object.assign({}, this.form);
                            obj.payPassword = md5(obj.payPassword);
                            obj.walletId = this.productId1;
                            this.axios.post("/withdraw/applyForMer", obj).then(res => {
                                if (res.code === 200) {

                                    this.$notify({
                                        title: '添加成功',
                                        message: res.msg,
                                        type: 'success'
                                    });

                                    this.$bus.$emit('refresh'); //通知刷新

                                    this.closeDialog();
                                } else {

                                    this.$notify.error({
                                        title: '添加失败',
                                        message: res.msg,
                                    });
                                }
                            })
                        } else {
                            return false;
                        }
                    });
                }

                if (this.action === "editMerchant") {
                    this.$refs['form'].validate((valid) => {
                        if (valid) {
                            this.axios.post("/merchant/updateMerchant", this.form).then(res => {
                                if (res.code === 200) {

                                    this.$notify({
                                        title: '添加成功',
                                        message: res.msg,
                                        type: 'success'
                                    });

                                    this.$bus.$emit('refresh'); //通知刷新

                                    this.closeDialog();
                                } else {

                                    this.$notify.error({
                                        title: '添加失败',
                                        message: res.msg,
                                    });
                                }
                            })
                        } else {
                            return false;
                        }
                    });
                }

            }
        },
        watch: {
            show(newVal) {
                this.dialogShow = newVal;
            },
            balance(newVal) {
                this.balance1 = newVal;
            },
            productId(newVal) {
                this.productId1 = newVal;

                console.log("openDialog");
                this.$axios.get("/merchant/getWithdrawFee", {params: {productId: this.productId1}}).then(res => {
                    if (res.code === 200) {
                        this.withdrawFee = res.data;
                    } else {
                        this.withdrawFee = "获取手续费失败,请稍后重试";
                    }

                }).catch(() => {
                    this.withdrawFee = "获取手续费失败,请稍后重试";
                })

            }
        },
        computed: {
            totalAmount() {
                return parseFloat(this.form.amount == '' ? '0' : this.form.amount) + parseFloat(this.withdrawFee);
            }
        }
    }
</script>

<style scoped>

</style>